import { all, takeEvery, call, put } from "redux-saga/effects";
import { healthCheck } from "services/apis/healthCheck";
import actions from "./actions";

function* loading(isLoading = false, error = false) {
  yield put({
    type: actions.SET_STATE,
    payload: {
      loading: isLoading,
      error,
    },
  });
}

export function* HEALTH_CHECK() {
  yield loading(true);

  const response = yield call(healthCheck);
  if (response) {
    yield put({
      type: actions.SET_STATE,
      payload: {
        detail: response,
        loading: false,
      },
    });
  }

  if (!response) {
    yield loading(false, true);
  }
}

export default function* rootSaga() {
  yield all([takeEvery(actions.HEALTH_CHECK, HEALTH_CHECK)]);
}
